'use strict';
angular.module('schoolLinqApp').factory('invoiceService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/invoice';

		function getInvoice(id) {
			return $http.get(endpoint, { params: { id: id } });
		}

		function searchInvoices(filter) {
			if (filter.statusId > 0) {
				filter.statusIds = [];
				filter.statusIds.push(filter.statusId);
			}

			return $http.get(endpoint + '/search', {
				params: {
					invoiceIds: filter.invoiceIds,
					invoiceType: filter.invoiceType,
					fromDate: filter.fromDate,
					toDate: filter.toDate,
					vendorId: filter.vendor ? filter.vendor.Id : null,
					employeeId: filter.employeeId,
					siteId: filter.site ? filter.site.Id : null,
					poFrom: filter.poFrom,
					poTo: filter.poTo,
					invoiceNumberStartsWith: filter.invoiceNumberStartsWith,
					overBudget: filter.overBudget,
					statusIds: filter.statusIds,
					dueOnOrBefore: filter.dueOnOrBefore,
					modifiedByUserName: filter.modifiedByUserName,
					fiscalYear: filter.fiscalYear,
					searchType: filter.searchType,
					bankId: filter.bankId,
					excludeVoided: filter.excludeVoided,
					paymentMethods: filter.paymentMethods ? filter.paymentMethods.join(',') : '',
				},
			});
		}

		function searchInvoiceChecks(filter) {
			return $http.get(endpoint + '/searchChecks', {
				params: {
					fromDate: filter.paymentDateFrom,
					toDate: filter.paymentDateTo,
					bankId: filter.bankId,
					methodsOfPayment: filter.methodsOfPayment,
					voided: filter.voided,
				},
			});
		}

		function voidACH(invoiceCheckIds, voidDate) {
			return $http.put(endpoint + '/void', { InvoiceCheckIds: invoiceCheckIds, VoidDate: voidDate });
		}

		function addInvoice(invoice) {
			return $http.put(endpoint, {
				...invoice,
				InvoiceDT: invoice.InvoiceDT.toDateString(),
				PostDT: invoice.PostDT.toDateString(),
				DueDT: invoice.DueDT.toDateString(),
			});
		}

		function addInvoices(invoices) {
			return $http.put(
				endpoint + '/addInvoices',
				invoices.map((invoice) => ({
					...invoice,
					InvoiceDT: invoice.InvoiceDT.toDateString(),
					PostDT: invoice.PostDT.toDateString(),
					DueDT: invoice.DueDT.toDateString(),
				}))
			);
		}

		function updateInvoice(invoice) {
			return $http.post(endpoint, {
				...invoice,
				InvoiceDT: invoice.InvoiceDT.toDateString(),
				PostDT: invoice.PostDT.toDateString(),
				DueDT: invoice.DueDT.toDateString(),
			});
		}

		function updatePRorFMACHInvoice(invoice) {
			return $http.post(endpoint + '/updatePRorFMACHInvoice', invoice);
		}

		function updateInvoiceEvents(invoice) {
			return $http.post(endpoint + '/updateInvoiceEvents', invoice);
		}

		function getFiscalYearsByVendorId(vendorId) {
			return $http.get(endpoint + '/fiscalyearsbyvendorid', {
				params: { vendorId: vendorId },
			});
		}

		function deleteInvoice(id) {
			return $http.delete(endpoint, { params: { id: id } });
		}

		function getEmployeeList() {
			return $http.get(endpoint + '/getEmployeeList');
		}

		function getModifiedByUserList() {
			return $http.get(endpoint + '/get-modified-by-user-list');
		}

		function getUnPaidACHCount() {
			return $http.get(endpoint + '/getunpaidachcount');
		}

		return {
			getInvoice: getInvoice,
			searchInvoices: searchInvoices,
			searchInvoiceChecks: searchInvoiceChecks,
			voidACH: voidACH,
			addInvoice: addInvoice,
			addInvoices: addInvoices,
			updateInvoice: updateInvoice,
			updatePRorFMACHInvoice: updatePRorFMACHInvoice,
			updateInvoiceEvents: updateInvoiceEvents,
			getFiscalYearsByVendorId: getFiscalYearsByVendorId,
			deleteInvoice: deleteInvoice,
			getEmployeeList: getEmployeeList,
			getModifiedByUserList: getModifiedByUserList,
			getUnPaidACHCount: getUnPaidACHCount,
		};
	},
]);
